import styled from 'styled-components';

const IosNativeDrawerSeparator = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
`;

export default IosNativeDrawerSeparator;
